import url_ from "asset-data:assets/galleries/ua-2021-12-09/L1000952-bw_0583998c87__800.jpg";
export const url = url_;